<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-2">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-12">
                  <span class="titulo bold">Nuevo Registro</span>
                </div>

                <div class="col-12 py-3">
                  <div class="pasos">
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 1, pasado: paso > 1 }"
                    >
                      <!-- <div class="numero">
                        <span>1</span>
                      </div> -->
                      <i class="icono fas fa-building fM"></i>
                      <div class="texto">
                        <span>Datos del contratante</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 2, pasado: paso > 2 }"
                    >
                      <!-- <div class="numero">
                        <span>2</span>
                      </div> -->
                      <i class="icono fas fa-file-alt fM"></i>
                      <div class="texto">
                        <span>Detalle de la póliza</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 3, pasado: paso > 3 }"
                    >
                      <!-- <div class="numero">
                        <span>3</span>
                      </div> -->
                      <i class="icono fas fa-user fM"></i>
                      <div class="texto">
                        <span>Datos del cliente</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 4, pasado: paso > 4 }"
                    >
                      <!-- <div class="numero">
                        <span>4</span>
                      </div> -->
                      <i class="icono fas fa-bicycle fM"></i>
                      <div class="texto">
                        <span>Datos de la bicicleta</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 5, pasado: paso > 5 }"
                    >
                      <!-- <div class="numero">
                        <span>5</span>
                      </div> -->
                      <i class="icono fas fa-shield-alt fM"></i>
                      <div class="texto">
                        <span>Cobertura</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="contenido pt-5">
                <form class="row mx-3" method="post">
                  <div
                    class="formulario col-12 bg-white shadow p-4 rounded card shadow"
                  >
                    <div class="row" v-show="paso == 1 && this.$store.state.user.id != 1">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Nombre de la compañía contratante</span>
                            <input
                              type="text"
                              v-model="form.contratante"
                              maxlength="100"
                              placeholder="Nombre de la compañía contratante"
                              required
                              readonly
                            />
                          </label>
                          <input type="hidden" v-model="form.admin_id">
                        </div>
                      </div>
                    </div>

                    <div class="row" v-show="paso == 1 && this.$store.state.user.id == 1">
                      <div class="col-md-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Selecciona un contratante</span>
                            <select v-model="form.admin_id" required>
                              <option value="">Contratante</option>
                              
                              <option :value="contratante.id" v-for="contratante in contratantes" :key="contratante.id">{{contratante.contratante}}</option>
                              
                            </select>
                          </label>
                        </div>
                      </div>
                    </div>


                    <div class="row" v-show="paso == 2">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <div class="col-md-12 pb-2">
                            <label>
                              <span>Número de póliza</span>
                              <input
                                type="text"
                                v-model="form.no_poliza"
                                maxlength="100"
                                placeholder="No hay número de póliza vigente"
                                required
                                readonly
                              />
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Inicio de vigencia</span>
                              <input
                                type="datetime-local"
                                v-model="form.vigencia_ini"
                                maxlength="100"
                                placeholder="Clic para seleccionar"
                                readonly
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Fin de vigencia</span>
                              <input
                                type="datetime-local"
                                v-model="form.vigencia_fin"
                                maxlength="100"
                                placeholder="Clic para seleccionar"
                                readonly
                                required
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-show="paso == 3">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <div class="col-12">
                            <label>
                              <input
                                type="checkbox"
                                v-model="form.usar_razon_social"
                                @change="razonSocialChange($event)"
                              />
                              <span>Usar razón social</span>
                            </label>
                          </div>
                          <div class="col-12 pb-2">
                            <label>
                              <input
                                type="text"
                                v-model="form.razon_social"
                                placeholder="Razón social"
                                :required="form.usar_razon_social"
                                :readonly="form.usar_razon_social == false"
                              />
                            </label>
                          </div>

                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Nombre(s)</span>
                              <input
                                type="text"
                                v-model="form.nombre"
                                maxlength="100"
                                placeholder="Nombre"
                                :required="form.usar_razon_social == false"
                                :readonly="form.usar_razon_social"
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Apellido Paterno</span>
                              <input
                                type="text"
                                v-model="form.apellido_paterno"
                                maxlength="100"
                                placeholder="Apellido paterno"
                                :required="form.usar_razon_social == false"
                                :readonly="form.usar_razon_social"
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Apellido materno</span>
                              <input
                                type="text"
                                v-model="form.apellido_materno"
                                maxlength="100"
                                placeholder="Apellido materno"
                                :required="form.usar_razon_social == false"
                                :readonly="form.usar_razon_social"
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>RFC</span>
                              <input
                                type="text"
                                v-model="form.rfc"
                                placeholder="RFC"
                                required
                              />
                            </label>
                          </div>

                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Correo Electrónico</span>
                              <input
                                type="text"
                                v-model="form.email"
                                maxlength="100"
                                placeholder="Correo Electrónico"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Verificar Correo Electrónico</span>
                              <input
                                type="text"
                                v-model="form.email2"
                                maxlength="100"
                                placeholder="Verificar Correo Electrónico"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Teléfono</span>
                              <input
                                type="text"
                                v-model="form.telefono"
                                maxlength="100"
                                placeholder="+52"
                                required
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Estado</span>
                              <!-- <input
                                type="text"
                                v-model="form.estado"
                                placeholder="Estado"
                              /> -->
                              <select v-model="form.estado" @change="estadoChange($event)" required>
                                <option value="">Estado</option>
                                <option :value="estado.c_estado" v-for="estado in estados" v-bind:key="estado.c_estado">{{estado.d_estado}}</option>
                              </select>
                            </label>
                          </div>

                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Municipio / Delegación</span>
                              <!-- <input
                                type="text"
                                v-model="form.municipio_o_del"
                                maxlength="100"
                                placeholder="Municipio / Delegación"
                                required
                              /> -->
                              <select v-model="form.municipio_o_del" @change="municipioChange($event)" required>
                                <option value="">Municipio / Delegación</option>
                                <option :value="municipio.c_mnpio" v-for="municipio in municipios" v-bind:key="municipio.c_mnpio">{{municipio.d_mnpio}}</option>
                              </select>
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Colonia</span>
                              <!-- <input
                                type="text"
                                v-model="form.colonia"
                                maxlength="100"
                                placeholder="Colonia"
                                required
                              /> -->
                              <select v-model="form.colonia" @change="coloniaChange($event)" required>
                                <option value="">Colonia</option>
                                <option :value="colonia.id_asenta_cpcons" v-for="colonia in colonias" v-bind:key="colonia.id_asenta_cpcons">{{colonia.d_asenta}}</option>
                              </select>
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Código Postal</span>
                              <input
                                type="text"
                                v-model="form.cp"
                                maxlength="5"
                                placeholder="CP"
                                required
                              />
                            </label>
                          </div>

                          <div class="col-md-8 pb-2">
                            <label>
                              <span>Calle</span>
                              <input
                                type="text"
                                v-model="form.calle"
                                maxlength="500"
                                placeholder="Calle"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-2 pb-2">
                            <label>
                              <span>No. Exterior</span>
                              <input
                                type="text"
                                v-model="form.no_ext"
                                maxlength="100"
                                placeholder="No. Ext"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-2 pb-2">
                            <label>
                              <span>No. Interior</span>
                              <input
                                type="text"
                                v-model="form.no_int"
                                maxlength="100"
                                placeholder="No. Int"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-show="paso == 4">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Marca</span>
                              <input
                                type="text"
                                v-model="form.marca"
                                maxlength="100"
                                placeholder="Marca"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Modelo</span>
                              <input
                                type="text"
                                v-model="form.modelo"
                                maxlength="150"
                                placeholder="Modelo"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-12 pb-2">
                            <label>
                              <span>No. de serie</span>
                              <input
                                type="text"
                                v-model="form.no_serie"
                                maxlength="100"
                                placeholder="No. de serie"
                                required
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Equipamiento Adicional</span>
                              <textarea
                                v-model="form.equipamiento_adicional"
                                class="w-100"
                                rows="4"
                              ></textarea>
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Descripción</span>
                              <textarea
                                v-model="form.descripcion"
                                class="w-100"
                                rows="4"
                                maxlength="150"
                                required
                              ></textarea>
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Valor Factura (incluyendo el valor del equipamiento)</span>
                              <input
                                type="number"
                                v-model="form.valor_factura"
                                placeholder="$"
                              />
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Año</span>
                              <input
                                type="number"
                                v-model="form.ano"
                                min="1111"
                                max="9999"
                                placeholder="Año"
                                required
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row resumen py-4" v-show="paso == 5">
                      <div class="col-12 pb-2 fC small">
                        Suma asegurada: ${{ form.valor_factura }}
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>PRIMA NETA</div>
                            <div class="bold fG">${{ form.prima_neta }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>DERECHOS DE PÓLIZA</div>
                            <div class="bold fG">
                              ${{ form.derecho_de_poliza }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>IVA</div>
                            <div class="bold fG">${{ form.iva }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>PRIMA TOTAL</div>
                            <div class="bold fG">${{ form.prima_total }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>COBERTURA BÁSICA</div>
                            <div class="bold fR px-5 py-2">
                              Deducible: {{form.cobertura_basica}}% del valor de la bicicleta
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center">
                        <div class="card border-round shadow">
                          <div>
                            <div>ROBO CON VIOLENCIA</div>
                            <div class="bold fR px-5 py-2">
                              Deducible: 10% del valor de la bicicleta
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center">
                        <div class="card border-round shadow">
                          <div>
                            <div>RESPONSABILIDAD CIVIL</div>
                            <div class="bold fR px-5 py-2">
                               Deducible: 10% de la pérdida con mínimo de 50 UMAS
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div
                          class="text-center pt-2 float-left"
                          v-show="paso > 1"
                        >
                          <button
                            type="button"
                            class="submit btnnaranja"
                            @click="regresar()"
                          >
                            REGRESAR
                          </button>
                        </div>
                        <div
                          class="text-center pt-2 float-right"
                          v-show="paso < 5"
                        >
                          <button
                            type="button"
                            class="submit btnnaranja"
                            @click="continuar()"
                          >
                            CONTINUAR
                          </button>
                        </div>
                        <div
                          class="text-center pt-2 float-right"
                          v-show="paso == 5"
                        >
                          <button
                            type="button"
                            @click="submitFormulario()"
                            class="submit btnnaranja"
                          >
                            FINALIZAR
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      paso: 1,
      cobertura_basica: null,
      form: {
        admin_id: "",
        contratante: "",
        no_poliza: "",
        no_certificado: "",
        vigencia_ini: "",
        vigencia_fin: "",
        usar_razon_social: false,
        razon_social: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        rfc: "",
        email: "",
        email2: "",
        telefono: "",
        estado: "",
        ciudad: "",
        municipio_o_del: "",
        colonia: "",
        cp: "",
        calle: "",
        no_ext: "",
        no_int: "",
        descripcion: "",
        marca: "",
        modelo: "",
        no_serie: "",
        equipamiento_adicional: "",
        valor_factura: "",
        ano: "",
        prima_neta: "",
        derecho_de_poliza: "",
        iva: "",
        prima_total: "",
        cobertura_basica: "",
        robo_con_violencia: "",
        responsabilidad_civil: "",
      },
      tiposervicio: "",
      columns: [
        "nombre",
        "email",
        "no_poliza",
        "no_certificado",
        "uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      estados: [],
      municipios: [],
      colonias: [],
      contratantes: [],
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));

    if(this.$store.state.user.id != 1){
      this.form.contratante = this.$store.state.user.contratante;
      this.form.admin_id = this.$store.state.user.admin_id;
    }

    AOS.init();

    this.consulta();
    this.getCoberturaBasica();
    this.consultaEstados();

    
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log({qData: JSON.stringify(qData)});

      this.$http
        .post(
          vm.$store.state.baseurl + "consulta-contratantes.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.contratantes = res.datos;
              

            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    consultaEstados(){

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-estados.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.estados = res.datos;
              console.log({estados: this.estados})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );

    },
    estadoChange(e){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-municipios.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.municipios = res.datos;
              this.form.municipio_o_del = "";
              this.form.colonia = "";
              this.form.cp = "";
              console.log({mnpios: this.municipios})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );


    },
    municipioChange(e){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-colonias.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.colonias = res.datos;
              this.form.colonia = "";
              this.form.cp = "";
              console.log({colonias: this.colonias})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );


    },
    coloniaChange(e){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del,
        id_asenta_cpcons: this.form.colonia
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-cp.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.cp = res.datos[0].d_codigo;
              console.log({cp: this.form.cp })
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );


    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.rfc = "";
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      if (this.validaPaso(this.paso) == false) {
        swal.fire(
          "Datos faltantes",
          "Por favor llena todos los campos del formulario antes de continuar.",
          "warning"
        );
        
        return;
      }

      if(this.form.valor_factura > 500000){
        
          swal.fire(
            "Valor Excedido",
            "El valor de la bicicleta no puede sobrepasar $500,000.00 MXN.",
            "warning"
          );
          return;
        

      }

      this.paso++;

      if(this.paso == 2){
        this.setVigenciaIni();
        this.getNoPolizaVigente();
        
        this.actualizaCobertura();

      }

      if (this.paso == 5) {
        //calcular prima, iva, etc
        let valor_factura = this.form.valor_factura;
        let prima_neta = 0;
        if (valor_factura > 0) {
          //calcular prima neta
          if (valor_factura <= 50000) {
            this.form.prima_neta = 862.06;
          } else if (valor_factura <= 100000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.052);
          } else if (valor_factura <= 300000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315);
          } else if (valor_factura <= 500000)  {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315);
          }
          //calcular derechos de poliza
          // // if (this.form.prima_neta <= 1000) {
          // //   this.form.derecho_de_poliza = 125.0;
          // // } else if (this.form.prima_neta <= 5000) {
          // //   this.form.derecho_de_poliza = 250.0;
          // // } else if (this.form.prima_neta <= 10000) {
          // //   this.form.derecho_de_poliza = 325.0;
          // // } else if (this.form.prima_neta <= 30000) {
          // //   this.form.derecho_de_poliza = 500.0;
          // // } else {
          // //   this.form.derecho_de_poliza = 700.0;
          // // }

          this.form.derecho_de_poliza = 0;

          //calcular iva
          this.form.iva = parseFloat(
            (parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza)) *
              0.16
          );
          this.form.prima_total = parseFloat(
            parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza) +
              parseFloat(this.form.iva)
          ).toFixed(2);

          this.form.prima_neta = this.form.prima_neta.toFixed(2);
          this.form.iva = this.form.iva.toFixed(2);

        }
      }
    },
    actualizaCobertura(){
      this.getCoberturaBasica();
      
    },
    getNoPolizaVigente(){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData.user_email = this.$store.state.user.user_email;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "get-no-poliza-vigente.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.form.no_poliza = res.no_poliza;

            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

    },
    regresar() {
      this.paso--;
    },
    validaPaso(paso) {
      var flag = false;

      if (paso == 1) {
        if (this.form.admin_id != "") {
          flag = true;
        }
      } else if (paso == 2) {
        if (
          this.form.no_poliza != "" &&
          this.form.vigencia_ini != "" &&
          this.form.vigencia_fin != ""
        ) {
          flag = true;
        }
      } else if (paso == 3) {
        if (
          this.form.rfc != "" &&
          this.form.email != "" &&
          this.form.email2 != "" &&
          this.form.telefono != "" &&
          this.form.estado != "" &&
          this.form.municipio_o_del != "" &&
          this.form.colonia != "" &&
          this.form.cp != "" &&
          this.form.calle != "" &&
          this.form.no_ext != ""
        ) {
          flag = true;
        }

        if (this.form.usar_razon_social == true) {
          if (this.form.razon_social == "") {
            flag = false;
          }
        } else {
          if (
            this.form.nombre == "" ||
            this.form.apellido_paterno == "" ||
            this.form.apellido_materno == ""
          ) {
            flag = false;
          }
        }
      } else if (paso == 4) {
        if (
          this.form.descripcion != "" &&
          this.form.marca != "" &&
          this.form.modelo != "" &&
          this.form.no_serie != "" &&
          this.form.valor_factura != "" &&
          this.form.ano != ""
        ) {
          flag = true;
        }
      }

      console.log({datos: this.form});

      return flag;
    },
    validaCamposVacios() {
      var flag = false;
      if (
        this.form.vigencia_ini != "" &&
        this.form.vigencia_fin != "" &&
        this.form.rfc != "" &&
        this.form.email != "" &&
        this.form.email2 != "" &&
        this.form.telefono != "" &&
        this.form.estado != "" &&
        this.form.municipio_o_del != "" &&
        this.form.colonia != "" &&
        this.form.cp != "" &&
        this.form.calle != "" &&
        this.form.no_ext != "" &&
        this.form.descripcion != "" &&
        this.form.marca != "" &&
        this.form.modelo != "" &&
        this.form.no_serie != "" &&
        this.form.valor_factura != "" &&
        this.form.ano != ""
      ) {
        flag = true;
      }

      if (this.form.usar_razon_social == true) {
        if (this.form.razon_social == "") {
          flag = false;
        }
      } else {
        if (
          this.form.nombre == "" ||
          this.form.apellido_paterno == "" ||
          this.form.apellido_materno == ""
        ) {
          flag = false;
        }
      }

      return flag;
    },
    submitFormulario() {
      //terminar
      //e.preventDefault();

      console.log('submit formulario');

      if (this.validaCamposVacios() == false) {
        swal.fire(
          "Datos faltantes",
          "Por favor llena todos los campos del formulario antes de continuar.",
          "warning"
        );
        return;
      }

      if (this.form.email != this.form.email2) {
        swal.fire(
          "Datos del cliente",
          "No coincide el campo de verificación de correo electrónico.",
          "warning"
        );
        return;
      }

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData.user_email = this.$store.state.user.user_email;

      if(this.$store.state.user.user_level == 1){
        qData.admin_id = this.form.admin_id;
      }else{
        qData.admin_id = this.$store.state.user.admin_id;
      }
      


      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "alta-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.$router.push("/dashboard");
              
              // swal
              //   .fire({
              //     title: "Registro",
              //     html: res.msg,
              //     confirmButtonText: `Ok`,
              //     icon: "success",
              //   })
              //   .then((result) => {
              //     /* Read more about isConfirmed, isDenied below */
              //     if (result.isConfirmed) {
              //       this.$router.push("/dashboard");
              //     }
              //   });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    setVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date();
      
      //this.form.vigencia_ini = this.formatDate(date) + "T12:00";
      this.form.vigencia_ini = this.formatDate(date) + "T" + this.formatTime(date);

      //console.log(this.form.vigencia_fin);

      this.changeVigenciaIni();
    },
    changeVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date(this.form.vigencia_ini);
      date.setFullYear(date.getFullYear() + 1);
      this.form.vigencia_fin =
        this.formatDate(date) + "T12:00";

      //console.log(this.form.vigencia_fin);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;

      return [hour, minute].join(":");
    },
    getCoberturaBasica() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        admin_id: this.form.admin_id
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "get-cobertura-basica.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;
            

            if (res.status == "ok") {
              console.log("ok");
              this.form.cobertura_basica = res.cobertura_basica;

              console.log({actualizacobertura: this.form})
             
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

